package com.fireavert.administration.super_admin_tools_page.client.presentation

import com.fireavert.administration.super_admin_tools_page.data_models.data_model.SmokeAlarmDurationRecordModel
import com.fireavert.administration.super_admin_tools_page.data_models.models.PropertyNotificationStatsModel
import com.fireavert.administration.super_admin_tools_page.data_models.models.PropertyOfflineStatisticsModel
import com.fireavert.administration.users_page.main_user_page.data_models.data_model.UserDTO
import com.fireavert.properties.shared.data_models.Property

data class WirelessIdSectionViewState(
    val wirelessDeviceId: String = "",
    val propertyName: String = "",
    val unitName: String = "",
    val deviceLocationLink: String = "",
    val gatewayDeviceData: Map<String, List<String>> = emptyMap(),
    val gatewayDeviceDataLoading: Boolean = false,
    val propertyOfflineStatistics: List<PropertyOfflineStatisticsModel> = emptyList(),
    val propertyNotificationStats: List<PropertyNotificationStatsModel> = emptyList(),
    val propertySmokeAlarmDurationStats: List<SmokeAlarmDurationRecordModel> = emptyList(),
    val propertyStatsLoading: Boolean = false,
    val appsheetDatabaseHealthStatus: Boolean = false,
    val appsheetDatabaseHealthLoading: Boolean = false,
    val testEmailSending: Boolean = false,
    val testEmailResponse: String = "",
    val adminUsers: List<UserDTO>? = emptyList(),
    val appsheetDatabaseLastChecked: String = "",
    val propertyList: List<Property> = emptyList(),
    val devicesOfflineSetting: Int = 10,
    val notificationsEnabled: Boolean = false
)